import React, { useCallback, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import {
  getInvestorProjectDetailEndpoint,
  updateProjectSearchTagsEndpoint,
} from '../services/investorService';
import useAdminEntity from '../../../hooks/useAdminEntity';
import {
  InvestorProjectDetail,
  ProjectSearchTagsForm,
} from '../models/investors';
import useAuth from '../../../hooks/useAuth';
import { SearchType } from '../constants/projectConstants';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';

const schema = yup.object({
  search_type: yup
    .mixed<SearchType>()
    .oneOf(['places', 'characteristics'])
    .required('El tipo de búsqueda es requerido'),
  values: yup.string().required('Los valores son requeridos'),
});

interface Props {
  id: string;
}

const useProjectSearchTags = ({ id: investorProjectId }: Props) => {
  const { isLoading, callEndpoint } = useCallApiAndLoad();
  const [errorAlert, setErrorAlert] = useState(null);
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const getProjectDetails = useCallback(
    () => getInvestorProjectDetailEndpoint(investorProjectId, token),
    [],
  );
  const [project] = useAdminEntity<InvestorProjectDetail>(
    getProjectDetails,
    setErrorAlert,
  );
  const globalAlertOptions = {
    success: false,
    warning: true,
    onConfirm: () => setErrorAlert(null),
    title: 'Error',
    text: errorAlert || '',
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm<ProjectSearchTagsForm>({
    resolver: yupResolver(schema),
    defaultValues: {
      search_type: '',
      values: '',
    },
  });

  // Aquí puedes agregar la lógica para llamar al endpoint
  const onSubmit = async (payload: ProjectSearchTagsForm) => {
    // Ejemplo de llamada al endpoint con fetch
    const { status, data } = await callEndpoint(
      updateProjectSearchTagsEndpoint(investorProjectId, payload, token),
    );
    if (status === 200) {
      // TODO add success alert
      reset();
      navigate(0);
    }
  };

  const onChangeSearchType = (event: any) => {
    const value = event.target.value as SearchType;
    console.log('onChangeSearchType', value);
    setValue('search_type', value);
    if (project?.search_tags && value) {
      const tagsArray = project.search_tags[value] || [];
      setValue('values', Array.isArray(tagsArray) ? tagsArray.join(', ') : '');
    } else {
      setValue('values', '');
    }
  };

  return {
    project,
    onChangeSearchType,
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    getValues,
    onSubmit,
  };
};

export default useProjectSearchTags;
